<template>
    <div class="main-visual">
        <swiper class="swiper" :options="swiperOptions">
            <template v-for="(slide, index) in slides">
                <swiper-slide :key="index">
                    <v-card flat tile :img="slide.image" class="main-visual__inner">
                        <div class="main-visual__text">
                            <template v-if="slide.title">
                                <tit-wrap class="tit-wrap--sm">
                                    <tit class="font-size-lg-32 font-weight-regular white--text">
                                        <div v-html="slide.title" />
                                        <div>
                                            <strong>더포디엄830 청년안심 주택</strong>
                                        </div>
                                    </tit>
                                </tit-wrap>
                            </template>
                            <template v-if="slide.text">
                                <txt class="txt--lg line-height-17 white--text">
                                    <div v-html="slide.text" />
                                </txt>
                            </template>
                        </div>
                    </v-card>
                </swiper-slide>
            </template>
        </swiper>
        <swiper-pagination-quarternary />
        <main-visual-requirement />
    </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import MainVisualRequirement from "@/components/client/main/main-visual/main-visual-requirement.vue";
import SwiperPaginationQuarternary from "@/components/publish/parents/swipers/swiper-pagination-quarternary.vue";
import Tit from "@/components/publish/styles/typography/tit.vue";
import TitWrap from "@/components/publish/styles/typography/tit-wrap.vue";
import Txt from "@/components/publish/styles/typography/txt.vue";
// import SwiperBtnWrapPrimary from "@/components/publish/parents/swipers/swiper-btn-wrap-primary.vue";
// import SwiperButtonPrimary from "@/components/publish/parents/swipers/swiper-button-primary.vue";
// import BtnArrowPrimary from "@/components/publish/parents/buttons/btn-arrow-primary.vue";

export default {
    components: {
        Swiper,
        SwiperSlide,
        MainVisualRequirement,
        SwiperPaginationQuarternary,
        Tit,
        TitWrap,
        Txt,
        // SwiperBtnWrapPrimary,
        // SwiperButtonPrimary,
        // BtnArrowPrimary,
    },
    props: {},
    data: () => ({
        swiperOptions: {
            effect: "fade",
            allowTouchMove: true,
            centeredSlides: true,
            spaceBetween: 0,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            speed: 500,
            loop: true,
        },
        slides: [
            {
                title: "편리한 생활을 즐길 수 있는 <br /><strong>건대입구</strong>에서 시작하는",
                text: "도보 5분 내 백화점-마트 등 편의시설 위치로 <br />편리하고 쾌적한 청년의 삶이 이루어 집니다.",
                image: "/images/main/visual-1.jpg",
            },
            {
                title: "인근 명문 대학교와 가까운 초중고 입지로 <br class='d-none d-sm-block' />청년과 신혼부부에게 편리한",
                text: "2호선 7호선 건대입구역과 강변북로, 올림픽대로 등을 통해 <br class='d-none d-sm-block' />서울 전역이 가까워 집니다.",
                image: "/images/main/visual-2.jpg",
            },
            {
                title: "인근 명문 대학교와 가까운 초중고 입지로 <br class='d-none d-sm-block' />청년과 신혼부부에게 편리한",
                text: "건국대, 세종대 등 주요 명문대학과 자양초중고가 인접해 있어 <br class='d-none d-sm-block' />교육 편의는 높이고 통학시간은 획기적으로 줄어듭니다.",
                image: "/images/main/visual-3.jpg",
            },
        ],
    }),
};
</script>

<style lang="scss" scoped>
.main-visual {
    max-width: 1920px;
    max-height: 880px;
    margin: 0 auto;
    position: relative;
    .swiper-container {
        position: static;
    }
    &__inner {
        height: 360px;
        padding: 50px var(--container-gutter);
        box-sizing: border-box;
    }
}
.swiper-pagination {
    top: 340px;
    bottom: initial;
    color: #fff;
}
@media (min-width: 1024px) {
    .main-visual {
        margin-top: var(--header-height);
    }
}
@media (min-width: 1200px) {
    .main-visual {
        height: calc(100vh - var(--header-height));
        margin-top: var(--header-height);
        display: flex;
        &__inner {
            height: 100%;
            padding: 240px 0 0 calc(240 / 1374 * 100%);
        }
    }
    .swiper-pagination {
        top: initial;
        bottom: 40px;
    }
}
</style>
